import { render } from "./referrals.vue?vue&type=template&id=e6e154a8"
import script from "./referrals.vue?vue&type=script&lang=js"
export * from "./referrals.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__